import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { isIndexableDeployment } from "./siteOrigin";

const DefaultSeo = () => {
  useLocation();

  if (isIndexableDeployment()) {
    return null;
  }

  return (
    <Helmet prioritizeSeoTags>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
    </Helmet>
  );
};

export default DefaultSeo;
